import { useEffect, useState } from 'react';

export default function XPToast({ show, xp = 20 }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (show) {
      setVisible(true);
      const t = setTimeout(() => setVisible(false), 2500);
      return () => clearTimeout(t);
    }
  }, [show]);

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', top: 80, right: 24, zIndex: 999,
      background: 'rgba(251,191,36,0.12)',
      border: '1px solid rgba(251,191,36,0.4)',
      borderRadius: 12, padding: '12px 20px',
      display: 'flex', alignItems: 'center', gap: 10,
      animation: 'xpSlideIn 0.35s ease',
      fontFamily: 'Inter, system-ui, sans-serif',
    }}>
      <span style={{ fontSize: 22 }}>⚡</span>
      <div>
        <div style={{ color: '#fbbf24', fontWeight: 700, fontSize: 15 }}>+{xp} XP</div>
        <div style={{ color: 'rgba(251,191,36,0.6)', fontSize: 12 }}>Lecke teljesítve!</div>
      </div>
      <style>{`
        @keyframes xpSlideIn {
          from { opacity: 0; transform: translateX(20px); }
          to   { opacity: 1; transform: translateX(0); }
        }
      `}</style>
    </div>
  );
}
